import { useState } from "react";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import {
  TEMPLATE_TEXT_MAX_LENGTH,
  exceedsTemplateAmountLimit,
  exceedsTemplateTextLimit,
  templateAmountLimitMessage,
  templateTextLimitMessage,
} from "./templateTextLimits";

const FEE_LABEL = "Application Fee";
const CLAUSE_LABEL = "Application Fee Clause";
// Long enough for "99999999.99" plus one extra character, so an over-cap value reaches
// onChange and shows the limit message instead of being silently cut by the native maxLength.
const FEE_INPUT_MAX_LENGTH = 12;

const FeeTemplete = ({
  postData,
  setPostData,
  feeError = false,
  feeErrorMessage = "",
  clauseError = false,
  clauseErrorMessage = "",
}) => {
  const [feeLimitError, setFeeLimitError] = useState("");
  const [clauseLimitError, setClauseLimitError] = useState("");
  const clause = postData?.leaseApplicationTemplateSections?.ApplicationFees?.clause ?? "";
  const feeMessage =
    feeLimitError || (feeError ? feeErrorMessage || `${FEE_LABEL} is required` : undefined);
  const clauseMessage =
    clauseLimitError || (clauseError ? clauseErrorMessage || `${CLAUSE_LABEL} is required` : undefined);
  return (
    <>
      <div className="feeCard">
        <div className="fees_left_section">
          <CustomInputs
            name={undefined}
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={postData?.leaseApplicationTemplateSections?.ApplicationFees?.fee}
            labelText={FEE_LABEL}
            isFormControl
            maxLength={FEE_INPUT_MAX_LENGTH}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (!/^\d*\.?\d{0,2}$/.test(inputValue)) return;
              if (exceedsTemplateAmountLimit(inputValue)) {
                setFeeLimitError(templateAmountLimitMessage());
                return;
              }
              setFeeLimitError("");
              setPostData((prev) => {
                const newData = { ...prev };
                newData.leaseApplicationTemplateSections = {
                  ...prev.leaseApplicationTemplateSections,
                  ApplicationFees: {
                    ...prev.leaseApplicationTemplateSections?.ApplicationFees,
                    fee: inputValue,
                  },
                };
                return newData;
              });
            }}
            required
            disabled={undefined}
            placeholder={FEE_LABEL}
            myClassName={undefined}
            isError={feeError || !!feeLimitError}
            errorMessages={feeMessage}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          /></div>
        <div className="fees_right_section">
          <CustomInputs
            name="signature"
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={clause}

            labelText={CLAUSE_LABEL}
            isFormControl
            // One over the limit so an over-long paste reaches onChange and shows the message
            // instead of being silently truncated by the native maxLength.
            maxLength={TEMPLATE_TEXT_MAX_LENGTH + 1}
            onChange={(e) => {
              if (exceedsTemplateTextLimit(e.target.value)) {
                setClauseLimitError(templateTextLimitMessage(CLAUSE_LABEL));
                return;
              }
              setClauseLimitError("");
              setPostData({
                ...postData,
                leaseApplicationTemplateSections: { ...postData.leaseApplicationTemplateSections, ApplicationFees: { ...postData?.leaseApplicationTemplateSections?.ApplicationFees, clause: e.target.value } }

              });
            }}
            required
            disabled={undefined}
            placeholder={"Enter Application Fee Clause"}
            myClassName={undefined}
            isError={clauseError || !!clauseLimitError}
            errorMessages={clauseMessage}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          />
          <div className="d-flex justify-content-end mb-2 w-100">
            <span
              className="sub_text grey_subtext1"
              style={{ fontSize: "11px", marginTop: "4px" }}
              data-testid="fee-clause-counter"
            >
              {String(clause).length}/{TEMPLATE_TEXT_MAX_LENGTH}
            </span>
          </div>

        </div>
      </div>
    </>
  );
};

export default FeeTemplete;
